import React from 'react';
import { ProjectPreviewWrapper, ProjectPhoto, TagContainer, TagBadge, ArrowBadge } from './styles';

interface IProjectPreviewProps {
    src: string;
    url: string;
    hoverText?: string;
    tags?: string[];
}

const ProjectPreview: React.FC<IProjectPreviewProps> = (props) => {
  return (<>
    <ProjectPreviewWrapper href={props.url} target='_blank'>
        <ProjectPhoto src={props.src}/>
        <ArrowBadge>View Project ↗</ArrowBadge>
    </ProjectPreviewWrapper>
    {props.tags && props.tags.length > 0 && (
      <TagContainer>
        {props.tags.map((tag, index) => (
          <TagBadge key={index}>{tag}</TagBadge>
        ))}
      </TagContainer>
    )}
  </>);
}

export default ProjectPreview;
